import React from "react";
import Table from "../../../../core/Table";

const LifeCycleHistoryLog = ({
  data,
  columns,
  paginationOptions,
  onTableChange
}) => {
  return (
    <>
      <Table
        data={data}
        columns={columns}
        paginationOptions={paginationOptions}
        onTableChange={onTableChange}
      />
    </>
  );
};

export default LifeCycleHistoryLog;
